import { render, staticRenderFns } from "./waterFallMobileBase.vue?vue&type=template&id=80e3ee82&"
import script from "./waterFallMobileBase.vue?vue&type=script&lang=js&"
export * from "./waterFallMobileBase.vue?vue&type=script&lang=js&"
import style0 from "./waterFallMobileBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports